(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-product-guard"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cart-product-guard')) {
    customElements.define(
      'cart-product-guard',
      class CartProductGuard extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.resetButton = this.querySelector('[data-cart-product-guard-reset]');
          this.errorMessage = this.querySelector('[data-cart-product-guard-error]');

          if (!this.dialog || !this.resetButton) return;

          this.dialog.addEventListener('cancel', (event) => event.preventDefault());
          this.resetButton.addEventListener('click', () => this.resetCart());

          if (!this.dialog.open) {
            this.dialog.showModal();
            this.dialog.focus({ preventScroll: true });
          }
        }

        async resetCart() {
          this.resetButton.disabled = true;
          this.resetButton.setAttribute('aria-busy', 'true');
          this.errorMessage.hidden = true;

          try {
            const response = await fetch(this.dataset.clearUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({}),
            });

            if (!response.ok) throw new Error(response.statusText);

            window.location.reload();
          } catch {
            this.errorMessage.hidden = false;
            this.resetButton.disabled = false;
            this.resetButton.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-popup"]) return;
  try {
    
  function initializeGlobalPopup(modal) {
    if (!modal || modal.dataset.globalPopupInitialized === 'true') return;

    // Header-group wrappers can establish a containing block for fixed children.
    // Keep the overlay at the document root so it can only render as a viewport popup.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    modal.dataset.globalPopupInitialized = 'true';
    const content = modal.querySelector('#popup-content-wrapper');
    const storageKey = modal.dataset.storageKey;
    const forceDisplayInDesignMode =
      modal.dataset.forceDisplayInDesignMode === 'true' &&
      window.Shopify &&
      window.Shopify.designMode;

    if (!sessionStorage.getItem(storageKey) || forceDisplayInDesignMode) {
      modal.style.display = 'flex';
    }

    function closePopup() {
      modal.style.display = 'none';
      sessionStorage.setItem(storageKey, 'true');
    }
    window.closePopup = closePopup;

    modal.addEventListener('click', function (event) {
      if (!content.contains(event.target)) {
        closePopup();
      }
    });
  }

  function initializeGlobalPopups(root) {
    root.querySelectorAll('[data-global-popup]').forEach(initializeGlobalPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeGlobalPopups(document);
    });
  } else {
    initializeGlobalPopups(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeGlobalPopups(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    const modal = event.target.querySelector('[data-global-popup]');
    if (modal && modal.dataset.forceDisplayInDesignMode === 'true') {
      modal.style.display = 'flex';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
